<template>
  <div class="product-edit">
    <div class="product-edit__content">


      <router-link :to="`/products/`" class="close">Закрыть</router-link>


      <div class="product-edit__title">{{product.title}}</div>

      <div class="product-edit__props">
        <div class="product-edit__prop">ID: {{ product.groupId }}</div>
        <div class="product-edit__prop">Кластер: {{product.cluster?product.cluster.title:''}}</div>
      </div>

      <div class="product-edit__two-cols">

        <div class="product-edit__inputs">
          <div class="product-edit__size form-block">

            <div class="form__block-title">Размер</div>

            <input-material parentClass="inline" label="Ширина" type="number"
                            @inputNumber="width = $event"
                            :valueNumber="product.width"

            ></input-material>
            <span>x</span>
            <input-material parentClass="inline" label="Высота" type="number"
                            @inputNumber="height = $event"
                            :valueNumber="product.height"
            ></input-material>
            <span>x</span>
            <input-material parentClass="inline" label="Глубина" type="number"
                            @inputNumber="depth = $event"
                            :valueNumber="product.depth"
            ></input-material>
          </div>

          <br>
          <div class="form__block-title">Фотографии упаковки</div>
          <div class="pictures">
            <drop-zone
                    :id="$route.params.id"
                    :productId="$route.params.id"
                    :initImage="photos.FRONT"
                    type="FRONT"
                    label="Перед" @uploaded="frontUploaded">
            </drop-zone>
            <drop-zone
                    :id="$route.params.id"
                    :productId="$route.params.id"
                    :initImage="photos.TOP"
                    type="TOP"
                    label="Верх" @uploaded="topUploaded">
            </drop-zone>
            <drop-zone
                    :id="$route.params.id"
                    :productId="$route.params.id"
                    :initImage="photos.RIGHT"
                    type="RIGHT"
                    label="Правая стенка" @uploaded="rightUploaded">
            </drop-zone>
            <drop-zone
                    :id="$route.params.id"
                    :productId="$route.params.id"
                    :initImage="photos.LEFT"
                    type="LEFT"
                    label="Левая стенка" @uploaded="leftUploaded">
            </drop-zone>
            <drop-zone
                    :id="$route.params.id"
                    :productId="$route.params.id"
                    :initImage="photos.BACK"
                    type="BACK"
                    label="Задняя стенка" @uploaded="backUploaded">
            </drop-zone>
            <drop-zone
                    :id="$route.params.id"
                    :productId="$route.params.id"
                    :initImage="photos.BOTTOM"
                    type="BOTTOM"
                    label="Низ" @uploaded="bottomUploaded">
            </drop-zone>
          </div>

        </div>
        <div class="product-edit__image">
          <div class="product-edit__change-camera">
            <div class="camera-angle" v-for="view in cameraViews"
                 v-bind:class="[ {active: (view.id === currentCameraView)}, view.id ]"
                 @click.prevent="currentCameraView = view.id"
            >{{view.title}}
            </div>
          </div>

          <div class="zoom">
            <div class="zoom__item" v-for="zoom in cameraZooms"
                 v-bind:class="{ active: (zoom.value === currentCameraZoom) }"
                 @click.prevent="previousCameraZoom = currentCameraZoom;  currentCameraZoom = zoom.value"
            >{{zoom.title}}
            </div>
          </div>

          <div class="product-edit__camera" :style="cameraPosition">
            <pack :initWidth="previewWidth"
                  :initHeight="previewHeight"
                  :initDepth="previewDepth"
                  :initFrontImg="photos.FRONT"
                  :initTopImg="photos.TOP"
                  :initRightImg="photos.RIGHT"
                  :initLeftImg="photos.LEFT"
                  :initBottomImg="photos.BOTTOM"
                  :initBackImg="photos.BACK"
                  :isMirrored="false"
                  :x="-110"
                  :y="-50"
                  :z="0"
                  class="pack-position"
                  :style="packStyle"
            ></pack>
          </div>
        </div>

      </div>


      <div class="product-edit__exit">

        <a href="#" @click.prevent="save" class="button">Сохранить и закрыть</a>

        <router-link :to="`/products/`" class="close-without-save">Закрыть без сохранения</router-link>

      </div>







    </div>
   </div>
</template>

<script>
import axios from 'axios';
import inputMaterial from '../html/InputMaterial';
import dropZone from '../DropZone';
import pack from '../Pack';

export default {
  name: 'product-edit',
  methods: {
    load() {
      const that = this;
      axios.get(`/api/v2/products/${this.$route.params.id}/`).then((response) => {
        that.isLoading = false;

        this.product = response.data;
        if (this.product.photos.length > 0) {
          const temp = Object.assign(...this.product.photos.map(
            o => ({ [o.side]: o.photo50 }),
          ));

          console.log(temp);

          Object.keys(temp).forEach((el) => {
            this.photos[el] = temp[el];
          });
        }
      });
    },
    frontUploaded(response) {
      this.photos.FRONT = response.image;
    },
    topUploaded(response) {
      this.photos.TOP = response.image;
    },
    leftUploaded(response) {
      this.photos.LEFT = response.image;
    },
    rightUploaded(response) {
      this.photos.RIGHT = response.image;
    },
    backUploaded(response) {
      this.photos.BACK = response.image;
    },
    bottomUploaded(response) {
      this.photos.BOTTOM = response.image;
    },
    save() {
      axios.patch(`/api/product/${this.product.id}`, {
        width: this.width || 0,
        height: this.height || 0,
        depth: this.depth || 0,
      }).then(() => {
        this.$router.replace({ path: '/products/' });
      });
    },
  },
  watch: {
    $route(to) {
      if (!to.params.id) {
        this.$router.replace({ path: '/products/' });
      }
    },
  },
  data() {
    return {
      bodyClassName: 'no-overflow',
      width: 0,
      height: 0,
      depth: 0,
      product: {},
      photos: {
        FRONT: '',
        BACK: '',
        TOP: '',
        BOTTOM: '',
        LEFT: '',
        RIGHT: '',
      },
      currentCameraView: 'right',
      currentCameraZoom: 2,
      previousCameraZoom: 2,
      cameraViews: {
        right: { title: 'Справа', id: 'right', rotationX: -20, rotationY: -20 },
        top: { title: 'Сверху', id: 'top', rotationX: -91, rotationY: 0 },
        back: { title: 'Сзади', id: 'back', rotationX: 0, rotationY: 180 },
        front: { title: 'Фронт', id: 'front', rotationX: -10, rotationY: 0 },
      },
      cameraZooms: {
        right: { title: '25%', value: 1 },
        top: { title: '50%', value: 2 },
        back: { title: '75%', value: 3 },
        front: { title: '100%', value: 4 },
      },
    };
  },
  computed: {
    scaleFactor() {
//      let scaleFactor = 1;
//      scaleFactor = Math.min(scaleFactor, 575 / (this.width + this.depth + this.height));

      return this.currentCameraZoom;
    },
    previewWidth() {
      return this.width * this.scaleFactor;
    },
    previewHeight() {
      return this.height * this.scaleFactor;
    },
    previewDepth() {
      return this.depth * this.scaleFactor;
    },
    packStyle() {
      return {
        transform: 'translate3d(-110px, -10px,0px)',
      };
    },
    cameraPosition() {
      return {
        transform: `rotateX(${this.cameraViews[this.currentCameraView].rotationX}deg) rotateY(${this.cameraViews[this.currentCameraView].rotationY}deg)`,
      };
    },
  },
  created() {
    this.load();
    document.body.classList.add(this.bodyClassName);
  },
  destroyed() {
    document.body.classList.remove(this.bodyClassName);
  },
  components: { inputMaterial, dropZone, pack },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

  .inline{
    display: inline-block;
    vertical-align: middle;
    width: 74px;
  }


  .zoom{
    position: absolute;
    right: 0;
    font-size: 12px;
    top: 20px;
    z-index: 10;

    &__item {
      display: inline-block;
      margin-right: 10px;
      border-bottom: 1px solid #3F6FA7;
      color:#3F6FA7;

      &.active{
        border-bottom: none;
        color:#333;
      }
    }
  }


  .product-edit{
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right: 0;
    background: #F4F6F8;
    z-index: 10;

    &__non-edit{
      font-size: 0;
      margin-right: 15px;
      margin-bottom: 15px;
    }

    &__two-cols{
    font-size: 0;
  }

    &__inputs{
      display: inline-block;
      vertical-align: top;
      width:292px;
      margin-right: 158px;
    }

    &__image{
      width: 400px;
      height: 400px;
      display: inline-block;
      vertical-align: top;
      background: #fff;
      overflow: hidden;
      position: relative;

    }

    &__change-camera{
      position: absolute;
      top:10px;
      left: 10px;
      z-index: 100;
    }

    &__camera{
      width: 400px;
      height: 400px;
      position: relative;
      transform-style: preserve-3d;
      transition: transform 1s linear;
      transform: rotateX(-20deg) rotateY(-20deg);
    }

    &__description{
      display: inline-block;
      vertical-align: top;
      width: 350px;
    }

    &__title{
      font-size: 35px;
      color: #262626;
      text-align: center;
      margin-bottom: 14px;
    }

    &__props{
      text-align: center;
      font-size: 0;
      margin-bottom: 50px;
    }

    &__prop{
      font-size: 14px;
      color: #88929D;
      line-height: 18px;
      display: inline-block;
      margin: 0 10px;
    }

    &__size{
      font-size: 12px;
      color: #768791;
      line-height: 21px;

      span{
        width: 20px;
        text-align: center;
        display: inline-block;
      }
    }

    &__size-title{
      font-size: 14px;
      color: #4A4A4A;
      line-height: 21px;
    }

    &__exit{
      padding: 40px 0 20px;
      text-align: center;
    }


  }

  .close-without-save{
    font-size: 14px;
    color: #3F6FA7;
    line-height: 18px;
    text-decoration: none;
    margin-left: 20px;
  }

  .product-edit__content{
    width: 890px;
    margin: 0 auto;
    padding: 70px 20px;
  }

  .pictures{
    margin: 0 -10px;
  }

  .pack-position{
    left:50%;
    top:50%;
  }

</style>



// WEBPACK FOOTER //
// ProductEdit.vue?876afb52